module.exports = __webpack_public_path__ + "static/media/mickey3_portuguese_5.21ec8b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mickey3_portuguese_5.png
// module id = 161
// module chunks = 0